module.exports = __webpack_public_path__ + "static/media/screen2.0a585449.png";